// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ak-4";
export var closeButton = "_ak-6";
export var dismissButton = "_ak-3";
export var editImageWithAiContainer = "_ak-8";
export var imageUploadWrapper = "_ak-7";
export var misspelledWord = "_ak-5";
export var spellCheckContainer = "_ak-2";
export var spin = "_ak-1";
export var spinning = "_ak-0";